import './help-me-choose-answers.scss';

import { t } from 'i18next';
import { parseAsInteger, useQueryStates } from 'nuqs';

import { Checkbox } from '@sola/ark-core/molecules/checkbox/checkbox.js';

import { SelectionCard } from '../../../molecules/selection-card/selection-card';
import { babyImage } from '../images/baby-help-me-choose';
import { childImage } from '../images/child-help-me-choose';
import { oldestImage } from '../images/oldest-help-me-choose';
import { teenImage } from '../images/teen-help-me-choose';

export const ageAnswers = [
  {
    id: 'baby',
    value: { min: 1, max: 5 },
    image: babyImage,
  },
  {
    id: 'child',
    value: { min: 6, max: 11 },
    image: childImage,
  },
  {
    id: 'teen',
    value: { min: 12, max: 17 },
    image: teenImage,
  },
  {
    id: 'adult',
    value: { min: 18, max: 22 },
    image: oldestImage,
  },
];

export const HelpMeChooseAge: React.FC = () => {
  const [ages, setAges] = useQueryStates({
    ageMin: parseAsInteger,
    ageMax: parseAsInteger,
  });
  const handleCheckboxChange = (
    value: { min: number; max: number },
    isChecked: boolean,
  ) => {
    if (isChecked) {
      setAges({ ageMin: value.min, ageMax: value.max });
    }
    if (!isChecked) {
      setAges(null);
    }
  };

  return (
    <div className="HelpMeChooseAnswers grid grid-cols-1 sm:grid-cols-2 gap-comfy-sm lg:flex lg:flex-row justify-center">
      {ageAnswers.map((card) => (
        <Checkbox
          name={card.id}
          fieldClasses="Checkbox__card"
          label={t(`help-me:ageAnswers.${card.id}`)}
          checked={
            (card.value.min === ages.ageMin &&
              card.value.max === ages.ageMax) as boolean
          }
          onChange={(e) =>
            handleCheckboxChange(card.value, e.currentTarget.checked)
          }
          labelContent={
            <SelectionCard
              variant="stacked"
              isChecked={
                (card.value.min === ages.ageMin &&
                  card.value.max === ages.ageMax) as boolean
              }
              details={{
                image: {
                  alt: t(`help-me:ageAnswers.${card.id}Alt`),
                  url: card.image,
                },
                label: t(`help-me:ageAnswers.${card.id}`),
                tinyTopText: t(`help-me:ageAnswers.${card.id}TopText`),
                primaryText: t(`help-me:ageAnswers.${card.id}`),
                primaryBody: t(`help-me:ageAnswers.${card.id}PrimaryBody`),
                secondaryTitle: t(`help-me:ageAnswers.${card.id}`),
                secondaryText: t(`help-me:ageAnswers.${card.id}SecondaryText`),
                value: t(`help-me:ageAnswers.${card.id}`),
              }}
            />
          }
        />
      ))}
    </div>
  );
};
